module.exports = __webpack_public_path__ + "img/pageLeftDis.19c58b2c.svg";